export default "__VITE_ASSET__DZ9Z3cNj__"